import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { ArrowUpRight } from 'lucide-react';
import logo from '../assets/logo.png';
import { RING_PATH } from './home/v3/LogoMark';

gsap.registerPlugin(ScrollTrigger, useGSAP);

const COLUMNS = [
  {
    title: 'Navegação',
    links: [
      { to: '/', label: 'Início' },
      { to: '/nosso-trabalho', label: 'Nosso Trabalho' },
      { to: '/sobre', label: 'Sobre' },
      { to: '/contato', label: 'Contato' },
    ],
  },
  {
    title: 'Projetos',
    links: [
      { to: '/apps/psicoid', label: 'PsicoID' },
      { to: '/apps/revyou', label: 'Revyou' },
      { to: '/apps/eg-treinos', label: 'EG Treinos' },
      { to: '/apps/meu-atalho', label: 'Meu Atalho' },
    ],
  },
];

/**
 * Rodapé: convite final grande, colunas e o anel do logo (vetor, nítido em
 * qualquer tamanho) se desenhando no canto e girando de leve com o scroll.
 */
function Footer() {
  const root = useRef(null);
  const year = new Date().getFullYear();

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', () => {
        const ring = root.current.querySelector('.ft-ring');
        const path = ring.querySelector('path');
        const len = path.getTotalLength();
        gsap.fromTo(
          path,
          { strokeDasharray: len, strokeDashoffset: len },
          { strokeDashoffset: 0, duration: 2, ease: 'power3.inOut', scrollTrigger: { trigger: root.current, start: 'top 85%' } }
        );
        gsap.fromTo(
          ring,
          { rotate: -35 },
          { rotate: 10, ease: 'none', scrollTrigger: { trigger: root.current, start: 'top bottom', end: 'bottom bottom', scrub: true } }
        );
        gsap.from(root.current.querySelectorAll('.ft-invite > span, .ft-col'), {
          y: 40,
          autoAlpha: 0,
          duration: 1.1,
          ease: 'expo.out',
          stagger: 0.08,
          scrollTrigger: { trigger: root.current, start: 'top 85%' },
        });
      });
      return () => mm.revert();
    },
    { scope: root }
  );

  return (
    <footer className="site-footer ft" ref={root}>
      <svg className="ft-ring" viewBox="26 26 162 162" aria-hidden focusable="false">
        <path d={RING_PATH} fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
      </svg>

      <div className="ft-wrap">
        <Link to="/contato" className="ft-invite">
          <span>Tem uma ideia?</span>
          <span className="ft-invite-line">
            Vamos tirar do papel.
            <ArrowUpRight className="ft-invite-arrow" size={56} strokeWidth={1.25} aria-hidden />
          </span>
        </Link>

        <div className="ft-grid">
          {COLUMNS.map((col) => (
            <nav className="ft-col" key={col.title} aria-label={col.title}>
              <h3 className="ft-col-title">{col.title}</h3>
              <ul>
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="ft-link">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
          <div className="ft-col">
            <h3 className="ft-col-title">Contato</h3>
            <ul>
              <li>
                <a className="ft-link" href="mailto:contato@idealizer.com.br">
                  contato@idealizer.com.br
                </a>
              </li>
              <li>
                <Link to="/politica-privacidade" className="ft-link">
                  Política de Privacidade
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="ft-bottom">
          <Link to="/" className="ft-logo" aria-label="Idealizer, página inicial">
            <img src={logo} alt="Idealizer" width="460" height="216" loading="lazy" />
          </Link>
          <span>© {year} Idealizer LTDA · CNPJ 57.325.737/0001-00</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
